class videoHelper{
	constructor() {
		this.bindVideoModal();
		this.bindVideoSourceConvert();
		this.videoKill();
	
		setTimeout(function() {
			$('.home-hero video').addClass('in');
		}, 200);
	}
	deferLoad(video) {
		if ( window.innerWidth < 992) {
			return;
		}
		video.querySelectorAll('source').forEach((source) => {
			source.setAttribute('src', source.getAttribute('data-src'));
		});
		video.load();
	}
	bindVideoModal() {
		var $this = this;
		var buttons = $('[data-toggle="modal-video"]');
		buttons.each(function(i, el) {
			$(this).click(function(e) {
				e.preventDefault();
				var target = $(this).data('target'),
					videoSrcUrl = $(this).data('videoSrc');	
	
				videoSrcUrl = $this.getEmbeddableVideoSource(videoSrcUrl, true);

				var iframe = $(target).find('iframe')[0];
				$(iframe).attr('src', videoSrcUrl);
				$(target).modal('show');
			});
		});
	}
	bindVideoSourceConvert() {
		var $this = this;
		var iframes = $('[data-convert-video]');
		iframes.each(function(i, el) {
			$(el).attr('src', $this.getEmbeddableVideoSource($(el).data('convertVideo'), false));
		});
	}
	videoKill() {
		if ($('.modal--video')[0]) {
			$('.modal--video').each(function () {
				var modal = $(this),
					btn = $(this).find('button.close')[0],
					tar = $(this).find('.modal-body')[0];
				$(btn).click(function (e) {
					e.preventDefault();
					$(tar).find('iframe').attr('src', null);
					modal.modal('hide');
				});
			});
		}
	}

	getEmbeddableVideoSource(videoSrcUrl, autoplay) {
		var youTubeVideoRegex = new RegExp("youtu(?:\.be|be\.com)/(?:.*v(?:/|=)|(?:.*/)?)([a-zA-Z0-9-_]+)");
		var vimeoVideoRegex = new RegExp("vimeo\.com/(?:.*#|.*/videos/)?([0-9]+)");
		var sproutVideoRegex = new RegExp("vids\.io/videos/(.*)/");

		var youtubeMatch = videoSrcUrl.match(youTubeVideoRegex);
		var vimeoMatch = videoSrcUrl.match(vimeoVideoRegex);
		var sproutMatch = videoSrcUrl.match(sproutVideoRegex);

		if (youtubeMatch) {
			videoSrcUrl = "//www.youtube.com/embed/" + youtubeMatch[1] + "?wmode=transparent&modestbranding=1&showinfo=0&rel=0" + (autoplay ? "&autoplay=1" : "");
		}
		if (vimeoMatch) {
			videoSrcUrl = "//player.vimeo.com/video/" + vimeoMatch[1] + (autoplay ? "?autoplay=1" : "");
		}
		if (sproutMatch) {
			videoSrcUrl = "//videos.sproutvideo.com/embed/" + sproutMatch[1] + "/aa0a0ed389c5e253?playerTheme=dark&amp;playerColor=";
		}

		return videoSrcUrl;
	}
}
window.app.add('video', new videoHelper());